module.exports = __webpack_public_path__ + "img/West-Mermis-Case-Study-400px.9bdfac9f.png";